<h1 class="mb-2 font-poppins text-[26px] font-medium leading-[32px] text-text-primary">
  {{ 'baa_signup_otp_title' | translate }}
</h1>

<h4 class="typo-h5-extralight text-text-secondary">
  {{ 'baa_signup_otp_subtitle' | translate }}
</h4>
<h4 class="typo-h5-semibold mt-3 text-text-secondary">
  {{ service.signerEmailSignal() }}
</h4>

<lib-otp-form
  [isLoading]="service.isOtpLoadingSignal()"
  [isResendLoading]="service.isResendLoadingSignal()"
  [isOtpError]="service.isOtpErrorSignal()"
  [backButtonRouterLink]="
    service.invitationOtpSourceSignal() === 'login'
      ? [...ffdNotesRoutePrefix(), routes.baaSignupFlow, routes.baaSignupLogin]
      : [...ffdNotesRoutePrefix(), routes.baaSignupFlow, routes.baaSignupAccountDetails]
  "
  [preserveParamsOnBack]="service.isInvitationFlowSignal()"
  (resendOtp)="onResendOtp()"
  (verifyOtp)="onVerifyOtp($event)"
></lib-otp-form>
